(() => {
  'use strict';

  if (window.migStickyAtc) {
    window.migStickyAtc.init(document);
    return;
  }

  const instances = new Map();
  const subscriptionSelector = '[data-loop-widget-purchase-option][data-loop-widget-selling-plan-group]';
  const selectedSelector = '.loop-widget-purchase-option-selected';

  function setText(element, text) {
    if (element.textContent !== text) element.textContent = text;
  }

  function setAttribute(element, name, value) {
    if (element.getAttribute(name) !== String(value)) element.setAttribute(name, value);
  }

  function mount(bar) {
    const section = document.getElementById(`shopify-section-${bar.dataset.sectionId}`);
    const form = document.getElementById(bar.dataset.formId);
    if (!section || !form || !section.contains(form) || instances.has(bar)) return;
    let nativeButton = form.querySelector('[data-atc-form]');
    if (!nativeButton) return;

    const variants = JSON.parse(bar.querySelector('[data-mig-sat-variants]').textContent);
    const button = bar.querySelector('.mig-sat-btn');
    const label = bar.querySelector('.mig-sat-label');
    const price = bar.querySelector('.mig-sat-price');
    const subscription = bar.querySelector('.mig-sat-sub');
    const media = window.matchMedia('(max-width: 1023px)');
    const events = new AbortController();
    const money = new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency', currency: bar.dataset.currency
    });
    let frame = 0;

    // Keep fixed positioning independent of transformed product media ancestors.
    document.body.appendChild(bar);
    section.classList.add('mig-sat-ready');

    function sync() {
      // Loop replaces this node to install its complete-pack add handler.
      nativeButton = form.querySelector('[data-atc-form]');
      if (!nativeButton) { button.disabled = true; return; }
      const variantId = form.querySelector('[name="id"]')?.value || bar.dataset.variantId;
      const variant = variants.find(item => String(item.id) === String(variantId));
      const option = section.querySelector(`${subscriptionSelector}${selectedSelector}`)
        || section.querySelector(subscriptionSelector);
      // Loop's frequency dropdown retains a value even during one-time purchase.
      // Its hidden form input is the authoritative purchase selection.
      const planInput = form.querySelector('input[type="hidden"][name="selling_plan"]');
      const planId = planInput ? planInput.value
        : option?.matches(selectedSelector) ? option.querySelector('[name="selling_plan"]')?.value : '';
      const allocation = variant?.plans.find(plan => String(plan.id) === String(planId));
      const available = Boolean(variant?.available);
      const busy = nativeButton.classList.contains('is--loading');
      const bis = form.querySelector('[data-mig-bis-trigger], .klaviyo-bis-trigger');

      bar.classList.toggle('is--visible', media.matches);
      bar.classList.toggle('is--unavailable', !available);
      setAttribute(bar, 'aria-hidden', !media.matches);
      button.disabled = available
        ? nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true' || busy
        : !bis;
      setAttribute(button, 'aria-busy', busy);
      setAttribute(button, 'aria-label', available ? 'A\u00f1adir al carrito' : 'Av\u00edsame cuando est\u00e9 disponible');
      setText(label, busy ? 'A\u00f1adiendo...\u00a0' : 'A\u00f1adir al carrito:\u00a0');
      if (variant) setText(price, money.format((allocation || variant).price / 100));

      if (subscription) {
        const offeredPlanId = option?.querySelector('[name="selling_plan"]')?.value;
        const offered = variant?.plans.find(plan => String(plan.id) === String(offeredPlanId))
          || variant?.plans[0];
        const saving = variant?.price > 0 && (allocation || offered)
          ? Math.max(0, Math.round((1 - (allocation || offered).price / variant.price) * 100)) : 0;
        const text = allocation
          ? saving ? `Te has ahorrado un ${saving}% para siempre` : 'Suscripci\u00f3n seleccionada'
          : saving ? `Suscr\u00edbete y ahorra ${saving}% para siempre` : 'Suscr\u00edbete';
        setText(subscription, text);
        subscription.disabled = !option || !available || !offered;
        setAttribute(subscription, 'aria-label', allocation
          ? `${subscription.textContent}. Ver frecuencia de suscripci\u00f3n` : subscription.textContent);
      }
    }

    function schedule() {
      if (frame) return;
      frame = requestAnimationFrame(() => {
        frame = 0;
        sync();
      });
    }

    // Watch insertion/replacement as well as changes inside an asynchronously loaded widget.
    const observer = new MutationObserver(records => {
      if (records.some(record => form.contains(record.target)
        || record.target.closest?.('.loop-widget-container')
        || record.type === 'childList')) schedule();
    });
    observer.observe(section, {
      subtree: true, childList: true, characterData: true, attributes: true,
      attributeFilter: ['class', 'value', 'disabled', 'aria-disabled']
    });
    ['change', 'input', 'click', 'variant:changed', 'theme:variant-change'].forEach(event => {
      section.addEventListener(event, schedule, { signal: events.signal });
    });
    // T4S emits a jQuery event, not a native CustomEvent.
    const jq = window.jQuery_T4NT;
    if (jq) jq(section).on('variant:changed.migStickyAtc', schedule);
    media.addEventListener('change', schedule);
    window.addEventListener('pageshow', schedule, { signal: events.signal });

    button.addEventListener('click', () => {
      sync();
      if (button.disabled) return;
      if (bar.classList.contains('is--unavailable')) {
        form.querySelector('[data-mig-bis-trigger], .klaviyo-bis-trigger')?.click();
        return;
      }
      if (!form.reportValidity()) return;
      // Preserve the theme's quantity, plan, properties, validation, cart drawer and errors.
      nativeButton.click();
      sync();
    }, { signal: events.signal });

    subscription?.addEventListener('click', () => {
      const option = section.querySelector(`${subscriptionSelector}${selectedSelector}`)
        || section.querySelector(subscriptionSelector);
      if (!option) return;
      if (!option.matches(selectedSelector)) option.click();
      option.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
        block: 'center'
      });
      (option.querySelector('select') || option).focus({ preventScroll: true });
      schedule();
    }, { signal: events.signal });

    instances.set(bar, () => {
      events.abort();
      observer.disconnect();
      cancelAnimationFrame(frame);
      media.removeEventListener('change', schedule);
      if (jq) jq(section).off('variant:changed.migStickyAtc', schedule);
      section.classList.remove('mig-sat-ready');
      bar.remove();
      instances.delete(bar);
    });
    sync();
  }

  function init(root) {
    root.querySelectorAll('.mig-sat-bar[data-form-id]').forEach(mount);
  }

  window.migStickyAtc = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((destroy, bar) => {
      if (bar.dataset.sectionId === event.detail.sectionId) destroy();
    });
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
